import * as R from 'ramda'

export const getFullName = (accountData) =>
  R.isNil(accountData.first_name)
    ? ''
    : `${accountData.first_name} ${R.pathOr('', ['last_name'], accountData)}`.trim()

export const getSurveyListFromIds = (allSurveyIds, surveysEntity) =>
  allSurveyIds.map((surveyId) => surveysEntity[surveyId])



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/NavBar/utils.js